import "core-js/modules/es.symbol";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.get-own-property-descriptors";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.parse-int";
import "core-js/modules/es.string.replace";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _defineProperty from "/Users/suifeng/Desktop/projects/2026/QianKunLong/QklAdmin/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import dayjs from 'dayjs';
import { mapActions } from 'vuex';
import localeMixin from '@/locales/mixin.js'; // import md5 from 'js-md5' // 如果 aes 用于加密密码，这个可能不再需要

import setting from '@/setting';
import user from '@/store/modules/d2admin/modules/user';
import util from '../../../libs/util';
import aes from './aes'; // 假设 googleCode 依然在当前目录下

import googleCode from './googleCode';
import { authCaptcha } from '@/api/apis';
export default {
  name: 'LoginPage_Updated',
  components: {
    googleCode: googleCode
  },
  mixins: [localeMixin],
  data: function data() {
    return {
      logoImg: require('@/assets/img/logo.png'),
      title: setting.projectName || '乾坤龙后台管理系统',
      time: dayjs().format('HH:mm:ss'),
      timeInterval: null,
      loading: false,
      // 增加登录 loading 状态
      errorMsg: '',
      // 用于顶部错误提示
      rememberMe: true,
      // 增加“记住我”
      captchaSvg: '',
      // 存储返回的 SVG
      captchaToken: '',
      // 存储返回的 Token
      // 表单数据
      formLogin: {
        username: '',
        password: '',
        code: '',
        // 谷歌验证码
        captcha_code: '' // 图片验证码输入内容

      },
      // 表单校验规则
      rules: {
        username: [{
          required: true,
          message: '请输入用户名',
          trigger: 'blur'
        }, {
          min: 3,
          max: 20,
          message: '长度在 3 到 20 个字符',
          trigger: 'blur'
        }],
        password: [{
          required: true,
          message: '请输入密码',
          trigger: 'blur'
        }, {
          min: 6,
          message: '密码不能少于 6 位',
          trigger: 'blur'
        }],
        code: [{
          required: true,
          message: '请输入验证码',
          trigger: 'blur'
        }],
        captcha_code: [{
          required: true,
          message: '请输入图片验证码',
          trigger: 'blur'
        }]
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    // 开启时间刷新
    this.timeInterval = setInterval(function () {
      _this.time = dayjs().format('HH:mm:ss');
    }, 1000);
    this.getCaptcha();
  },
  beforeDestroy: function beforeDestroy() {
    // 清除定时器
    if (this.timeInterval) {
      clearInterval(this.timeInterval);
    }
  },
  methods: _objectSpread({}, mapActions('d2admin/account', ['login']), {
    getCaptcha: function getCaptcha() {
      var res;
      return regeneratorRuntime.async(function getCaptcha$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return regeneratorRuntime.awrap(authCaptcha());

            case 3:
              res = _context.sent;

              // 假设返回结构是 { data: { img: '<svg...', captcha_token: 'xxx' } }
              // 如果你的接口直接返回 res，请根据实际情况调整
              if (res) {
                this.captchaSvg = res.svg;
                this.captchaToken = res.token;
              }

              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              this.$message.error('获取验证码失败');

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, null, this, [[0, 7]]);
    },

    /**
     * @description 提交登录表单
     */
    submit: function submit() {
      var _this2 = this;

      var account, errCount;
      return regeneratorRuntime.async(function submit$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              this.errorMsg = ''; // 清空之前的错误

              account = this.formLogin.username; // 1. 连续密码错误锁定检查 (保留原逻辑)

              if (!(setting.loginConfig && setting.loginConfig.pwdError && setting.loginConfig.pwdError.enable)) {
                _context3.next = 7;
                break;
              }

              errCount = util.cookies.get('errCount_' + account);

              if (!(errCount >= setting.loginConfig.pwdError.errorCount)) {
                _context3.next = 7;
                break;
              }

              this.errorMsg = "\u60A8\u5DF2\u8FDE\u7EED\u8F93\u5165".concat(errCount, "\u6B21\u9519\u8BEF\u5BC6\u7801\uFF0C").concat(setting.loginConfig.pwdError.lockMinute, "\u5206\u949F\u540E\u53EF\u518D\u6B21\u767B\u5F55");
              return _context3.abrupt("return");

            case 7:
              // 2. 表单预校验
              this.$refs.loginForm.validate(function _callee(valid) {
                var pwd, _errCount;

                return regeneratorRuntime.async(function _callee$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        if (!valid) {
                          _context2.next = 18;
                          break;
                        }

                        _this2.loading = true; // 开启 loading
                        // 3. 密码加密 (AES)

                        pwd = aes.encrypt(_this2.formLogin.password);
                        console.log('pwd', pwd); // 4. 执行登录 Action

                        _context2.prev = 4;
                        _context2.next = 7;
                        return regeneratorRuntime.awrap(_this2.login({
                          account: account,
                          pwd: pwd,
                          code: _this2.formLogin.code,
                          captcha_code: _this2.formLogin.captcha_code,
                          // 用户输入的图片验证码
                          captcha_token: _this2.captchaToken // 接口返回的 Token

                        }));

                      case 7:
                        // 5. 登录成功处理
                        _this2.$tempModel.powerOf = function (tid) {
                          if (!tid || tid === '') {
                            return true;
                          }

                          var userRules = user.state.info.rules_ids;

                          if (userRules.indexOf(parseInt(tid)) >= 0) {
                            return true;
                          }

                          return false;
                        }; // 重置错误计数


                        util.cookies.set('errCount_' + account, 0); // 重定向

                        _this2.$router.replace('/index');

                        _context2.next = 16;
                        break;

                      case 12:
                        _context2.prev = 12;
                        _context2.t0 = _context2["catch"](4);
                        // 6. 登录失败处理
                        _this2.loading = false; // 关闭 loading

                        if (_context2.t0.message === '密码错误') {
                          if (setting.loginConfig && setting.loginConfig.pwdError && setting.loginConfig.pwdError.enable) {
                            _errCount = util.cookies.get('errCount_' + account);
                            _errCount = !_errCount ? 0 : parseInt(_errCount + '');
                            _errCount += 1;
                            util.cookies.set('errCount_' + account, _errCount + '', {
                              expires: 1 / (24 * 60) * setting.loginConfig.pwdError.lockMinute
                            });
                            _this2.errorMsg = "\u8FDE\u7EED\u8F93\u5165\u5BC6\u7801\u9519\u8BEF".concat(_errCount, "\u6B21\u3002\u8FDE\u7EED\u9519\u8BEF").concat(setting.loginConfig.pwdError.errorCount, "\u6B21\u5C06\u9501\u5B9A\u8D26\u6237").concat(setting.loginConfig.pwdError.lockMinute, "\u5206\u949F");
                          } else {
                            _this2.errorMsg = '密码不正确，请重新输入';
                          }
                        } else {
                          _this2.errorMsg = _context2.t0.message || '登录失败，请重试';
                        }

                      case 16:
                        _context2.next = 19;
                        break;

                      case 18:
                        // 登录表单校验失败
                        _this2.$message.error('表单校验失败，请检查填写');

                      case 19:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, null, null, [[4, 12]]);
              });

            case 8:
            case "end":
              return _context3.stop();
          }
        }
      }, null, this);
    },
    clickBindCode: function clickBindCode() {
      this.$refs.googleCode.show();
    }
  })
};